import type { MsdfConfig, MsdfFont } from '../../../types'

const loadImageAsync = (url: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.onload = () => {
      resolve(image)
    }
    image.onerror = () => {
      reject(new Error(`Не удалось загрузить изображение с URL: ${url}`))
    }
    image.src = url
  })
}

export const loadFontAtlasAsync = async (
  fontPath: string,
  fontConfig: MsdfConfig,
): Promise<MsdfFont> => {
  return {
    atlas: await loadImageAsync(fontPath),
    config: fontConfig,
  }
}
